// extracted by mini-css-extract-plugin
export default {"root":"Order_root__HuONk","main":"Order_main__ISZpf","secondary":"Order_secondary__Zhde5"};